module.exports = __webpack_public_path__ + "img/manufacture.7010e0c5.jpg";